import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { CommonService } from '../services/common.service';
import { HttpClient } from '@angular/common/http';
import { IGetOperationResponse } from '../interfaces/IGetOperationResponse';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { LoaderService } from '../services/loader.service';


@Injectable({
  providedIn: 'root'
})
export class HavePermissionToAccessComponentGuard implements CanActivate {
  private canAccessComponent: boolean = false;
  private baseUrl: string;

  constructor(private commonservice: CommonService, private http: HttpClient, private router: Router, private appConfig: AppConfigService) {
    this.baseUrl = this.appConfig.getAppConfig().AppUrl;
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    LoaderService.showLoader();
    console.log(route);
    console.log(route.data);
    let componentCode = route.data.componentCode;
    let userAction = route.data.userAction;

    return this.http.get(this.baseUrl + '/api/UserDataManager/IsEligibleFor?componentCode=' + componentCode + "&userAction=" + userAction).pipe(map((response: IGetOperationResponse<boolean>) => {

      if (response && response.Result) {
        // LoaderService.hideLoader();
        this.canAccessComponent = true;
        return this.canAccessComponent;
      } else {
        this.router.navigateByUrl('/unauthorized');
        LoaderService.hideLoader();
        return false;
      }
    }), catchError(err => {
      LoaderService.hideLoader()
      return of(false);
    }));


  }
  path: import("@angular/router").ActivatedRouteSnapshot[]; route: import("@angular/router").ActivatedRouteSnapshot;

}
